import CarIconExported from './CarIcon';
import LocateIconExported from './LocateIcon';
import TestDriveExported from './TestDrive';
import HomeServiceExported from './HomeService';
import TrackingOrderExported from './TrackingOrder';
import WhatsappExported from './Whatsapp';
import ServiceCarIconExported from './ServiceCarIcon';
import NavHomeIconExported from './NavHomeIcon';
import AskCsIcon2Exported from './AskCsIcon2';
import NavLogoExported from './NavLogo';
import GeoLocationExported from './GeoLocation';
import FacebookIconExported from './FacebookIcon';
import TiktokIconExported from './TiktokIcon';
import XlogoExported from './Xlogo';
import LongReceiptExported from './LongReceipt';
import ArrowSplitExported from './ArrowSplit';
import GarageExported from './Garage';
import GarageHomeExported from './GarageHome';
import PhoneInTalkExported from './PhoneInTalk';
import DirectionsCarExported from './DirectionsCar';
import DropDownArrowExported from './DropDownArrow';
import DropUpArrowExported from './DropUpArrow';
import GradeExported from './Grade';
import ArrowForwardExported from './ArrowForward';
import SubmitIconExported from './SubmitIcon';
import BodyPaintExported from './BodyPaint';
import SearchIconExported from './SearchIcon';
import CloseCircleExported from './CloseCircle';
import LogoGooglePlayExported from './LogoGooglePlay';
import LogoAppStoreExported from './LogoAppStore';
import InformationExported from './Information';
import InformationFilledExported from './InformationFiled';
import FilterIconHeaderExported from './FilterIconHeader';
import AddIconExported from './AddIcon';
import MinusIconExported from './MinusIcon';
import PhoneIconHeaderExported from './PhoneIconHeader';
import LocationIconHeaderExported from './LocationIconHeader';
import PersonIconHeaderExported from './PersonIconHeader';
import PersonRedIconHeaderExported from './PersonRedIconHeader';
import BoldCloseIconExported from './BoldCloseIcon';
import ArrowLeftExported from './ArrowLeft';
import ArrowRightExported from './ArrowRight';
import LockIconExported from './LockIcon';
import BackToTopExported from './BackToTop';
import CopyrightIconExported from './CopyrightIcon';
import CloseModalChoosePlaceIconExported from './CloseModalChoosePlaceIcon';
import ClockIconExported from './ClockIcon';
import PlusBoldIconExported from './PlusBoldIcon';
import AlertIconExported from './AlertIcon';
import ArrowBackExported from './ArrowBack';
import TrashIconExported from './TrashIcon';
import PencilIconExported from './PencilIcon';
import QuickReferenceAllExported from './QuickReferenceAll';
import ArrowDropDownExported from './ArrowDropDown';
import DeleteOutllineExported from './DeleteOutlline';
import CarSilhoutteExported from './CarSilhoutte';
import EditIconExported from './EditIcon';
import AppsMenuIconExported from './AppsMenuIcon';
import ArrowDropUpExported from './ArrowDropUp';
import PlaylistAddCheckExported from './PlaylistAddCheck';
import MapExported from './Map';
import ProfileImagePlaceholderExported from './ProfileImagePlaceholder';
import PlaceholderUploadFileExported from './PlaceholderUploadFile';
import ArrowLeftPaginationExported from './ArrowLeftPagination';
import ArrowRightPaginationExported from './ArrowRightPagination';
import ArrowDropDownTapExported from './ArrowDropDownTap';
import DeleteInlineExported from './DeleteInline';
import ImageiconExported from './ImageIcon';
import MemberOfAstraIconExported from './MemberOfAstraIcon';
import EmployeeDevelopmentIconExported from './EmployeeDevelopmentIcon';
import LeaderEmpowerementIconExported from './LeaderEmpowerementIcon';
import ConduciveCoworkerIconExported from './ConduciveCoworkerIcon';
import FillInstagramIconExported from './FillInstagramIcon';
import LinkedInIconExported from './LinkedInIcon';
import ArrowTriangleLeftIconExported from './ArrowTriangleLeftIcon';
import ArrowTriangleRightIconExported from './ArrowTriangleRightIcon';
import AchievementIconExported from './AchievementIcon';
import PhoneExported from './PhoneIcons';
import CheckCircleExported from './CheckCircle';
import CheckCircleFillExported from './CheckCircleFill';
import CalendarIconExported from './CalendarIcon';
import SortIconExported from './SortIcon';
import FilterIconExported from './FilterIcon';
import BellNotificationExported from './BellNotification';
import MessageIconExported from './MessageIcon';
import PromoIconExported from './PromoIcon';
import NewsAndTIpsIconExported from './NewsAndTIpsIcon';
import GalleryConsumenIconExported from './GalleryConsumenIcon';
import ViewOutlineIconExported from './ViewOutline';
import ButtonNavigationLeftExported from './ButtonNavigation/left';
import ButtonNavigationRightExported from './ButtonNavigation/right';
import WorkIconExported from './WorkIcon';
import LocalOfferIconExported from './LocalOffer';
import InsertDriveIconExported from './InsertDrive';
import BookIconExported from './BookIcon';
import MailIconExported from './MailIcon';
import UserGroupExported from './UserGroup';
import CaretIconExported from './CaretIcon';
import NavHomeIconFillExported from './NavHomeIconFill';
import CarIconFillExported from './CarIconFill';
import SeoStaticPageMenuCMSExported from './SeoStaticPageMenuCMS';
import RedChecklistExported from './RedChecklist';
import PercentIconExported from './PercentIcon';
import RightIconExported from './RightIcon';
import CalenderIconExported from './CalenderIcon';
import TagIconExported from './TagIcon';
import ShopIconExported from './ShopIcon';
import ClockServicesIconExported from './ClockServicesIcon';
import ThumbIconExported from './ThumbIcon';
import LocationCheckedIconExported from './LocationCheckedIcon';
import ArrowExported from './Arrow';
import CuponServiceIconExported from './CuponServiceIcon';
import CloudUploadIconExported from './CloudUpload';
import ToolsExported from './Tools';
import QuotationMarkExported from './QuotationMark';
import VisiIconExported from './VisiIcon';
import MisiIconExported from './MisiIcon';
import QRCodeIconExported from './QRCodeIcon';
import ShareIconExported from './ShareIcon';
import DownloadIconExported from './DownloadIcon';
import CarAndKeyAboveIconExported from './CarAndKeyAbove';
import MyOrdersIconExported from './MyOrdersIcon';
import TestDriveFillIconExported from './TestDriveFill';
import ToolsOutlineIconExported from './ToolsOutline';
import UnlockIconExported from './UnlockIcon';
import VoucherIconExported from './VoucherIcon';
import LogoutIconExported from './LogoutIcon';
import HandphoneIconExported from './HandphoneIcon';
import CurrentLocationIconExported from './CurrentLocationIcon';
import DownloadOutlineIconExported from './DownloadOutlineIcon';
import ShareOutlineIconExported from './ShareOutlineIcon';
import HistoryIconExported from './HistoryIcon';
import BellNotificationFilledExported from './BellNotificationFilled';
import MarkerIconExported from './MarkerIcon';
import CopyIconExported from './CopyIcon';
import UploadImageExported from './UploadImage';
import FillProfileIconExported from './FillProfileIcon';
import TextFromDeviceIconExported from './TextFromDeviceIcon';
import TransactionIconExported from './TransactionIcon';
import CopyLineIconExported from './CopyLineIcon';
import BCAIconExported from './BCAIcon';
import RefreshIconExported from './RefreshIcon';
import WalletWithMoneyAndCardIconExported from './WalletWithMoneyAndCardIcon';
import ArrowNoLineExported from './ArrowNoLine';
import FileDownloadIconExported from './FileDownloadIcon';
import FooterDesktopExported from './FooterDesktop';
import FooterMobileExported from './FooterMobile';
import CalendarTimeIconExported from './CalendarTimeIcon';
import CarServiceIconExported from './CarServiceIcon';
import MaskIconExported from './MaskIcon';
import PaymentIconExported from './PaymentIcon';
import ServiceIconExported from './ServiceIcon';
import SignatureIconExported from './SignatureIcon';
import FullPaymentIconExported from './FullPayment';
import CarTransactionIconExported from './CarTransaction';
import HomeTransactionIconExported from './HomeTransaction';
import FinishTransactionIconExported from './FinishTransaction';
import FillPersonIconExported from './FillPersonIcon';
import QrisIconExported from './QrisIcon';
import GpnIconExported from './GpnIcon';
import BRIIconExported from './Banks/BRIIcon';
import MandiriIconExported from './Banks/MandiriIcon';
import DanamonIconExported from './Banks/DanamonIcon';
import PermataIconExported from './Banks/PermataIcon';
import MayBankIconExported from './Banks/MayBank';
import CIMBNiagaIconExported from './Banks/CIMBNiagaIcon';
import BTNIconExported from './Banks/BTNIcon';
import BTPNIconExported from './Banks/BTPNIcon';
import ArthaGrahaIconExported from './Banks/ArthaGrahaIcon';
import MaspionIconExported from './Banks/MaspionIcon';
import CycleIconExported from './CycleIcon';
import DanaIconExported from './EWallet/DanaIcon';
import LinkAjaIconExported from './EWallet/LinkAjaIcon';
import OvoIconExported from './EWallet/OVOIcon';
import P2pLineIconExported from './P2pLineIcon';

export const CarIcon = CarIconExported;
export const LocateIcon = LocateIconExported;
export const TestDrive = TestDriveExported;
export const HomeService = HomeServiceExported;
export const TrackingOrder = TrackingOrderExported;
export const Whatsapp = WhatsappExported;
export const ServiceCarIcon = ServiceCarIconExported;
export const NavHomeIcon = NavHomeIconExported;
export const AskCsIcon2 = AskCsIcon2Exported;
export const NavLogo = NavLogoExported;
export const GeoLocation = GeoLocationExported;
export const FacebookIcon = FacebookIconExported;
export const TiktokIcon = TiktokIconExported;
export const Xlogo = XlogoExported;
export const LongReceipt = LongReceiptExported;
export const ArrowSplit = ArrowSplitExported;
export const Garage = GarageExported;
export const GarageHome = GarageHomeExported;
export const PhoneInTalk = PhoneInTalkExported;
export const DirectionsCar = DirectionsCarExported;
export const DropDownArrow = DropDownArrowExported;
export const DropUpArrow = DropUpArrowExported;
export const Grade = GradeExported;
export const ArrowForward = ArrowForwardExported;
export const SubmitIcon = SubmitIconExported;
export const BodyPaint = BodyPaintExported;
export const SearchIcon = SearchIconExported;
export const CloseCircle = CloseCircleExported;
export const LogoGooglePlay = LogoGooglePlayExported;
export const LogoAppStore = LogoAppStoreExported;
export const Information = InformationExported;
export const InformationFilled = InformationFilledExported;
export const FilterIconHeader = FilterIconHeaderExported;
export const AddIcon = AddIconExported;
export const MinusIcon = MinusIconExported;
export const PhoneIconHeader = PhoneIconHeaderExported;
export const LocationIconHeader = LocationIconHeaderExported;
export const PersonIconHeader = PersonIconHeaderExported;
export const PersonRedIconHeader = PersonRedIconHeaderExported;
export const BoldCloseIcon = BoldCloseIconExported;
export const ArrowLeft = ArrowLeftExported;
export const ArrowRight = ArrowRightExported;
export const LockIcon = LockIconExported;
export const BackToTop = BackToTopExported;
export const CopyrightIcon = CopyrightIconExported;
export const CloseModalChoosePlaceIcon = CloseModalChoosePlaceIconExported;
export const ClockIcon = ClockIconExported;
export const PlusBoldIcon = PlusBoldIconExported;
export const AlertIcon = AlertIconExported;
export const ArrowBack = ArrowBackExported;
export const TrashIcon = TrashIconExported;
export const PencilIcon = PencilIconExported;
export const QuickReferenceAll = QuickReferenceAllExported;
export const ArrowDropDown = ArrowDropDownExported;
export const DeleteOutlline = DeleteOutllineExported;
export const CarSilhoutte = CarSilhoutteExported;
export const EditIcon = EditIconExported;
export const AppsMenuIcon = AppsMenuIconExported;
export const ArrowDropUp = ArrowDropUpExported;
export const PlaylistAddCheck = PlaylistAddCheckExported;
export const Map = MapExported;
export const ProfileImagePlaceholder = ProfileImagePlaceholderExported;
export const PlaceholderUploadFile = PlaceholderUploadFileExported;
export const ArrowLeftPagination = ArrowLeftPaginationExported;
export const ArrowRightPagination = ArrowRightPaginationExported;
export const ArrowDropDownTap = ArrowDropDownTapExported;
export const DeleteInline = DeleteInlineExported;
export const Imageicon = ImageiconExported;
export const MemberOfAstraIcon = MemberOfAstraIconExported;
export const EmployeeDevelopmentIcon = EmployeeDevelopmentIconExported;
export const LeaderEmpowerementIcon = LeaderEmpowerementIconExported;
export const ConduciveCoworkerIcon = ConduciveCoworkerIconExported;
export const FillInstagramIcon = FillInstagramIconExported;
export const LinkedInIcon = LinkedInIconExported;
export const ArrowTriangleLeftIcon = ArrowTriangleLeftIconExported;
export const ArrowTriangleRightIcon = ArrowTriangleRightIconExported;
export const AchievementIcon = AchievementIconExported;
export const Phone = PhoneExported;
export const CheckCircle = CheckCircleExported;
export const CheckCircleFill = CheckCircleFillExported;
export const CalendarIcon = CalendarIconExported;
export const SortIcon = SortIconExported;
export const FilterIcon = FilterIconExported;
export const BellNotification = BellNotificationExported;
export const MessageIcon = MessageIconExported;
export const PromoIcon = PromoIconExported;
export const NewsAndTIpsIcon = NewsAndTIpsIconExported;
export const GalleryConsumenIcon = GalleryConsumenIconExported;
export const ViewOutlineIcon = ViewOutlineIconExported;
export const ButtonNavigationLeft = ButtonNavigationLeftExported;
export const ButtonNavigationRight = ButtonNavigationRightExported;
export const WorkIcon = WorkIconExported;
export const LocalOfferIcon = LocalOfferIconExported;
export const InsertDriveIcon = InsertDriveIconExported;
export const BookIcon = BookIconExported;
export const MailIcon = MailIconExported;
export const UserGroupIcon = UserGroupExported;
export const CaretIcon = CaretIconExported;
export const NavHomeIconFill = NavHomeIconFillExported;
export const CarIconFill = CarIconFillExported;
export const SeoStaticPageMenuCMS = SeoStaticPageMenuCMSExported;
export const RedChecklist = RedChecklistExported;
export const PercentIcon = PercentIconExported;
export const RightIcon = RightIconExported;
export const CalenderIcon = CalenderIconExported;
export const TagIcon = TagIconExported;
export const ShopIcon = ShopIconExported;
export const ClockServicesIcon = ClockServicesIconExported;
export const ThumbIcon = ThumbIconExported;
export const LocationCheckedIcon = LocationCheckedIconExported;
export const Arrow = ArrowExported;
export const CuponServiceIcon = CuponServiceIconExported;
export const ToolsIcon = ToolsExported;
export const CloudUpload = CloudUploadIconExported;
export const QuotationMark = QuotationMarkExported;
export const VisiIcon = VisiIconExported;
export const MisiIcon = MisiIconExported;
export const QRCodeIcon = QRCodeIconExported;
export const ShareIcon = ShareIconExported;
export const DownloadIcon = DownloadIconExported;
export const CarAndKeyAboveIcon = CarAndKeyAboveIconExported;
export const MyOrdersIcon = MyOrdersIconExported;
export const TestDriveFillIcon = TestDriveFillIconExported;
export const ToolsOutlineIcon = ToolsOutlineIconExported;
export const UnlockIcon = UnlockIconExported;
export const VoucherIcon = VoucherIconExported;
export const LogoutIcon = LogoutIconExported;
export const HandphoneIcon = HandphoneIconExported;
export const CurrentLocationIcon = CurrentLocationIconExported;
export const DownloadOutlineIcon = DownloadOutlineIconExported;
export const ShareOutlineIcon = ShareOutlineIconExported;
export const HistoryIcon = HistoryIconExported;
export const BellNotificationFilledIcon = BellNotificationFilledExported;
export const MarkerIcon = MarkerIconExported;
export const CopyIcon = CopyIconExported;
export const UploadImage = UploadImageExported;
export const FillProfileIcon = FillProfileIconExported;
export const TextFromDeviceIcon = TextFromDeviceIconExported;
export const TransactionIcon = TransactionIconExported;
export const CopyLineIcon = CopyLineIconExported;
export const BCAIcon = BCAIconExported;
export const RefreshIcon = RefreshIconExported;
export const WalletWithMoneyAndCardIcon = WalletWithMoneyAndCardIconExported;
export const ArrowNoLine = ArrowNoLineExported;
export const FileDownloadIcon = FileDownloadIconExported;
export const BRIIcon = BRIIconExported;
export const MandiriIcon = MandiriIconExported;
export const DanamonIcon = DanamonIconExported;
export const PermataIcon = PermataIconExported;
export const MayBankIcon = MayBankIconExported;
export const CIMBNiagaIcon = CIMBNiagaIconExported;
export const BTNIcon = BTNIconExported;
export const BTPNIcon = BTPNIconExported;
export const ArthaGrahaIcon = ArthaGrahaIconExported;
export const MaspionIcon = MaspionIconExported;
export const CycleIcon = CycleIconExported;

// E-Wallet
export const DanaIcon = DanaIconExported;
export const LinkAjaIcon = LinkAjaIconExported;
export const OvoIcon = OvoIconExported;
export const FooterDesktop = FooterDesktopExported;
export const FooterMobile = FooterMobileExported;
export const CalendarTimeIcon = CalendarTimeIconExported;
export const CarServiceIcon = CarServiceIconExported;
export const MaskIcon = MaskIconExported;
export const PaymentIcon = PaymentIconExported;
export const ServiceIcon = ServiceIconExported;
export const SignatureIcon = SignatureIconExported;
export const FullPaymentIcon = FullPaymentIconExported;
export const CarTransactionIcon = CarTransactionIconExported;
export const HomeTransactionIcon = HomeTransactionIconExported;
export const FinishTransactionIcon = FinishTransactionIconExported;
export const FillPersonIcon = FillPersonIconExported;
export const QrisIcon = QrisIconExported;
export const GpnIcon = GpnIconExported;
export const P2pLineIcon = P2pLineIconExported;
